export default __webpack_public_path__ + "static/media/print.55866c7c.svg";